'use client';

var ESearchable;
(function (ESearchable) {
    ESearchable[ESearchable["On"] = 1] = "On";
    ESearchable[ESearchable["Off"] = 0] = "Off";
})(ESearchable || (ESearchable = {}));
var EResumeType;
(function (EResumeType) {
    EResumeType[EResumeType["Attach"] = 1] = "Attach";
    EResumeType[EResumeType["ProfileOnline"] = 0] = "ProfileOnline";
})(EResumeType || (EResumeType = {}));

export { EResumeType, ESearchable };
//# sourceMappingURL=types.js.map
